import React from 'react';
import styled from 'styled-components';
import theme from '../theme';
import { Link } from "react-router-dom";

const ContenedorPassword = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
    width: 100%;
    padding: 20px 0;
    height: auto;
`;

const Enlace = styled(Link)`
    color: ${theme.verdeFecha};
    font-size: 20px;
    text-align: center;
    text-decoration: none;
    transition: color 500ms;

    &:hover {
        color: ${theme.verdeClaro};
    }
`;


const RecoverPassword = () => {
    return (  
        <ContenedorPassword>
            <Enlace to='/recuperar-contrasena'>
                ¿Olvidaste tu contraseña?
            </Enlace>
        </ContenedorPassword>
    );
}
 
export default RecoverPassword;